import { ConversationalChatInputComponent } from '@klant/conversational/conversational-chat-input/conversational-chat-input.component';

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

import { ApContentPipe } from '@ap/content';
import { ApIconComponent } from '@ap/icon';
import { ApNotificationComponent } from '@ap/notification';
import { ApChatTextareaComponent } from '@ap/textarea/chat';

/**
 * @ngdoc module
 * @name ConversationalChatInputModule
 **/
@NgModule({
    declarations: [ConversationalChatInputComponent],
    imports: [ApContentPipe, FormsModule, ApIconComponent, ApNotificationComponent, ApChatTextareaComponent, ReactiveFormsModule, NgClass],
    exports: [ConversationalChatInputComponent]
})
export class ConversationalChatInputModule {}
